import { Modal } from "@mui/material";
import { SettingContext } from "context/SettingContext";
import React, { useContext, useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { ReactComponent as SearchIconPlaceHolder } from "assets/icons/searchicon.svg";
import { Badge, Box, Divider, IconButton, styled, Toolbar, InputBase } from "@mui/material";
import pickFile from "assets/setting/freepik--Folder--inject-63.png";
import pickFile2 from "assets/setting/pickFile2.svg";

import USPCard from "features/Setting/Product_USP_and_Gallery/USPCard";
import Button from "components/ui/Button";
import { useQuery } from "@tanstack/react-query";
import { fetchDesignData, useGetExcatDesign } from "../API/addBtnApi";
import { transformUspData } from "utils/transformdata";
import ProductSkeleton from "components/ui/Skeleton/ProductSkeleton";
import axios from "axios";
import apiClient from "lib/api-client";
import config from "configs/config";
import { toast } from "react-toastify";

const modalTitleStyle = {
  color: "#8B8B8B",
  fontFamily: "Poppins, sans-serif",
  fontSize: "1.19vw",
  fontWeight: 500,
  letterSpacing: "0.41px",
  lineHeight: "22px",
};

const closeBtnStyle = {
  background: "none",
  border: "none",
  color: "#8B8B8B",
  cursor: "pointer",
  fontSize: "22px",
  padding: 0,
  lineHeight: 1,
  width: "32px",
  height: "32px",
  borderRadius: "4px",
  border: "1px solid #8B8B8B",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};
const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "black",
  height: "40px",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 1),
    transition: theme.transitions.create("width"),

    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "40ch",
    },
  },
}));

// demo card data
const cardData = {
  _id: "68382ec2a55872962a42832a",
  jewelId: 5246,
  jewelCode: "25P896",
  __v: 0,
  baseMetalCode: "G18KP",
  baseStoneCode: "FCRNDVSGH",
  createdAt: "2025-05-29T09:54:09.601Z",
  csPcs: 0,
  csWt: 0,
  diaPcs: 94,
  diaQlty: "VSGH",
  diaWt: 0.777,
  goldColor: "Pink",
  goldQlty: "18K",
  grossWt: 8.81,
  itemSize: null,
  location: "Headquarters Stock",
  makeDate: "2025-05-29T00:00:00.000Z",
  netWt: 8.655,
  otherPcs: 0,
  otherWt: 0,
  styleNumber: "BA-01840",
  updatedAt: "2025-05-29T09:59:48.277Z",
  id: "68150374a55872962a22da24",
  styleDate: "2025-05-02T00:00:00.000Z",
  bestSeller: true,
  designClass: "Bronze",
  totalSales: 0,
  categoryName: "Bali",
  collectionDetails: [],
  setDetails: [],
  imageUrl: "https://style-imagesss.s3.ap-south-1.amazonaws.com/2025-05-02/BA-01840.jpg",
  transformedImageUrl: "https://transform-imagesss.s3.ap-south-1.amazonaws.com/2025-05-02/BA-01840.webp",
};

function AddDesignModal({ open, isDetail, uspDetailData, setIsDetail, existingData }) {
  const { setAddModalOpen } = useContext(SettingContext);
  const [searchValue, setSearchValue] = useState("");
  const [designToFetch, setDesignToFetch] = useState("");
  const [showCard, setShowCard] = useState(false);
  const [cardData, setCardData] = useState({});
  const [selectedDesigns, setSelectedDesigns] = useState([]);

  const handleProceedButton = () => {
    if (selectedDesigns.length > 0 && cardData.styleNumber) {
      const url = `/Setting/product-usp-and-gallery/edit-uspDetails/${cardData.styleNumber}?isEdit=false`;
      window.open(url, "_blank");
    }
    setAddModalOpen(false);
    setSearchValue("");
    setShowCard(false);
    sessionStorage.removeItem("uspSelectedDesigns");
  };

  const handleCloneApply = async () => {
    const clonePayload = {
      cloneFrom: uspDetailData?.styleNumber,
      newDesigns: selectedDesigns.map((obj) => obj?.designNumber),
    };

    try {
      const cloneResponse = await apiClient.post(`${config.baseUrl}/api/v1/styles/cloneUspDesignData`, clonePayload);

      if (cloneResponse?.data?.status === 200) {
        toast.success(`${cloneResponse?.data?.message}`, {
          autoClose: 1000,
          hideProgressBar: false,
        });
        handleCloseAddModal();
        setIsDetail(false);
      } else {
        toast.error(`${cloneResponse?.data?.message || "Something went wrong"}`, {
          autoClose: 1000,
          hideProgressBar: false,
        });
      }
    } catch (error) {
      const message = error?.response?.data?.message || error?.message || "Something went wrong";

      toast.error(`Error: ${message}`, {
        autoClose: 1000,
        hideProgressBar: false,
      });
    }
  };

  const handleSearchInputChange = (e) => {
    const value = e.target.value;
    setSearchValue(value);
    setShowCard(false);
  };

  const handleSearchOrClear = () => {
    if (showCard) {
      setSearchValue("");
      setShowCard(false);
      setDesignToFetch("");
    } else if (searchValue.trim() !== "") {
      const value = searchValue.trim();

      let designExist = existingData?.filter((obj) => obj.styleNumber.toUpperCase() === value.toUpperCase());

      if (designExist.length > 0) {
        toast.error("Design Alredy Exist in Table", {
          autoClose: 1000,
          hideProgressBar: false,
        });
      } else {
        setDesignToFetch(value);
      }
    }
  };

  const handleCloseAddModal = () => {
    setAddModalOpen(false);
    setDesignToFetch("");
    setShowCard(false);
    setSearchValue("");
    sessionStorage.removeItem("uspSelectedDesigns");
  };

  const addToUsp = (design) => {
    let uspSelectedDesigns = JSON.parse(sessionStorage.getItem("uspSelectedDesigns")) || [];
    // Prevent duplicate entries
    const isAlreadyAdded = uspSelectedDesigns.some((item) => item.designNumber === design.designNumber);
    if (!isAlreadyAdded) {
      uspSelectedDesigns.push(design);
      sessionStorage.setItem("uspSelectedDesigns", JSON.stringify(uspSelectedDesigns));
    }
    fetchSelectedDesigns();
    setShowCard(false);
    setSearchValue("");
  };

  const removeFromUsp = (designNumber) => {
    let uspSelectedDesigns = JSON.parse(sessionStorage.getItem("uspSelectedDesigns")) || [];
    uspSelectedDesigns = uspSelectedDesigns.filter((item) => item.designNumber !== designNumber);
    sessionStorage.setItem("uspSelectedDesigns", JSON.stringify(uspSelectedDesigns));
    fetchSelectedDesigns();
  };
  const fetchSelectedDesigns = () => {
    const savedDesigns = JSON.parse(sessionStorage.getItem("uspSelectedDesigns")) || [];
    setSelectedDesigns(savedDesigns);
  };

  //   ------------- API ---------------\\

  const { data, isLoading, isError, error } = useGetExcatDesign(designToFetch);

  useEffect(() => {
    if (data && searchValue !== "") {
      setShowCard(true);
      setCardData(data);
    }
  }, [data]);

  useEffect(() => {
    if (open) {
      fetchSelectedDesigns();
    }
  }, [open]);
  return (
    <>
      <Modal
        open={open}
        onClose={() => handleCloseAddModal()}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            bgcolor: "#101010",
            borderRadius: "12px",
            p: "16px",
            pb: "0px",
            pt: "0px",
            width: "72vw",
            height: "80vh",
            marginTop: "5vw",
          }}
        >
          <Box sx={{ height: "100%", width: "100%", display: "flex", flexDirection: "column", bgcolor: "#191818" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexDirection: "row", height: "100%", gap: "0.4vw" }}>
              <Box sx={{ height: "100%", width: "100%", bgcolor: "#101010", padding: "1.23vw 0.9vw 0px 0px" }}>
                {/* Header */}
                <Box sx={{ width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center", height: "2vw" }}>
                  <span style={modalTitleStyle}>{isDetail ? `${uspDetailData?.styleNumber} Details` : "Select Design"}</span>
                </Box>
                {/* Search Bar */}
                <Box sx={{ mt: "1.6vw", width: "100%" }}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      width: "100%",
                      background: "#fff",
                      borderRadius: "5px",
                      boxShadow: "inset 0px 4px 20px 0px #00000040",
                      height: "2.6vw",
                      width: "33.2vw",
                      position: "relative",
                    }}
                  >
                    <SearchIconPlaceHolder
                      style={{
                        position: "absolute",
                        left: 12,
                        top: "50%",
                        transform: "translateY(-50%)",
                        color: "gray",
                        width: "1.4vw",
                        height: "1.4vw",
                        pointerEvents: "none",
                      }}
                    />
                    <StyledInputBase
                      placeholder="Search Design Number"
                      sx={{
                        pl: "2.7vw",
                        // pr: "100px",
                        width: "100%",
                        height: "2.7vw",
                        fontFamily: "Karla",
                        fontSize: "1vw",
                        borderRadius: "5px",
                        background: "transparent",
                        color: "#000",
                      }}
                      value={searchValue}
                      onChange={handleSearchInputChange}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          handleSearchOrClear();
                        }
                      }}
                      inputProps={{ "aria-label": "search design number" }}
                    />
                    <IconButton
                      disableRipple
                      disableFocusRipple
                      sx={{
                        position: "absolute",
                        right: 6,
                        top: "50%",
                        transform: "translateY(-50%)",
                        height: "2.1vw",
                        padding: "0.5vw !important",
                        width: "4.1vw",
                        borderRadius: "5px",
                        background: "#000",
                        color: "#fff",
                        fontFamily: "Poppins",
                        fontWeight: 500,
                        fontSize: "0.9vw",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                      onClick={handleSearchOrClear}
                    >
                      {showCard ? "Clear" : "Search"}
                    </IconButton>
                  </Box>
                </Box>

                {/* Design Card */}
                {!showCard && !isLoading ? (
                  <Box sx={{ width: "100%", height: "56vh", display: "flex", alignItems: "center", justifyContent: "center", color: "white", flexDirection: "column" }}>
                    <img src={pickFile} style={{ height: "14vh", width: "10.2vw" }} />
                    <span style={{ fontFamily: 400, fontSize: "0.6vw", fontFamily: "Poppins", color: "#8b8b8b", marginTop: "0.2vw" }}>Please, select Design</span>
                  </Box>
                ) : (
                  <Box
                    sx={{
                      width: "100%",
                      height: "39vh",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "start",
                      color: "white",
                      flexDirection: "column",
                      paddingTop: "1vw",
                    }}
                  >
                    {isLoading ? (
                      <div>
                        <ProductSkeleton />
                      </div>
                    ) : (
                      <USPCard data={transformUspData(data)} showBtn={true} addToUsp={addToUsp} removeFromUsp={removeFromUsp} />
                    )}
                  </Box>
                )}
              </Box>

              <Box sx={{ height: "100%", width: "100%", bgcolor: "#101010", padding: "20px 0px 0px 15px" }}>
                {/* Header */}
                <Box sx={{ width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center", height: "28px" }}>
                  <span style={modalTitleStyle}>Selected Designs - {selectedDesigns.length}</span>

                  <button style={closeBtnStyle} onClick={handleCloseAddModal} aria-label="Close">
                    <CloseIcon fontSize="inherit" />
                  </button>
                </Box>
                {/* Here i want to show selected design which is in session instantaly */}
                {selectedDesigns.length === 0 ? (
                  <Box sx={{ width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center", color: "white", flexDirection: "column" }}>
                    <img src={pickFile2} width={"155.3px"} height={"101.1px"} />
                    <span style={{ fontFamily: 400, fontSize: "10px", fontFamily: "Poppins", color: "#8b8b8b", marginLeft: "-12px", marginTop: "4px" }}>Selected designs will shown here</span>
                  </Box>
                ) : (
                  <Box
                    sx={{
                      width: "100%",
                      height: "100%",
                      maxHeight: "64vh",
                      marginTop: "1vw",
                      overflow: "auto",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "start",
                      color: "white",
                      flexDirection: "column",
                      gap: "1.2vw",
                      scrollbarWidth: "thin",
                      scrollbarColor: "#999 transparent",
                      background: "#101010",
                    }}
                  >
                    {selectedDesigns.map((design, index) => (
                      <USPCard key={index} data={design} showBtn={true} removeFromUsp={removeFromUsp} />
                    ))}
                  </Box>
                )}
              </Box>
            </div>

            {/* Proceed Button */}
            <Box
              sx={{
                width: "auto",
                height: "3.9vw",
                bgcolor: "#191818",
                px: "1vw",
                py: "0.9vw",
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                borderBottomLeftRadius: "12px",
                borderBottomRightRadius: "12px",
                marginLeft: "-16px",
                marginRight: "-16px",
              }}
            >
              <Button
                sx={{
                  width: "7.2vw",
                  height: "4.8vh",
                  borderRadius: "0.4vw",
                  border: "none",
                  bgcolor: selectedDesigns.length > 0 ? "#50C878" : "#8b8b8b",
                  color: "#000",
                  fontWeight: 700,
                  fontSize: "0.95vw",
                  "&:hover": { bgcolor: selectedDesigns.length > 0 ? "#50C878" : "#8b8b8b", color: "#000" },
                }}
                onClick={isDetail ? handleCloneApply : handleProceedButton}
              >
                {isDetail ? "Apply" : "Proceed"}
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </>
  );
}

export default AddDesignModal;
